var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Right Arrow"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-324.000000, -1157.000000)","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("path",{"d":"M341.013141,1157.29384 L351.169884,1167.47793 L341.013135,1177.66184 L339.597028,1176.24952 L347.309,1168.51584 L324,1168.51602 L324,1166.51602 L347.385,1166.51584 L339.597028,1158.70616 L341.013141,1157.29384 Z"})))]);
}

Arrow.defaultProps = {"width":"28px","height":"21px","viewBox":"0 0 28 21","version":"1.1","aria-hidden":"true"};

module.exports = Arrow;

Arrow.default = Arrow;
